import {
  Button,
  FileUploader,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  UploadedFile,
  VStack,
} from '@elkaso-app/web-design';
import { useBulkUploadCSVFileApi } from 'apis/restaurants/use-bulk-upload-csv-file-api';
import { usePageParams } from 'hooks/use-page-params';
import { useState } from 'react';

interface IBulkUploadModal {
  isOpen: boolean;
  onClose: any;
}

export const BulkUploadModal = ({ isOpen, onClose }: IBulkUploadModal) => {
  const [file, setFile] = useState<UploadedFile>();
  const { getPageParams } = usePageParams();
  const { restaurantId } = getPageParams();
  const { mutate: bulkUpload, isLoading } = useBulkUploadCSVFileApi(restaurantId as string);

  const onUploadButton = () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file as File);

    const variables = {
      body: formData,
    };

    bulkUpload(variables, {
      onSuccess: () => {
        setFile(undefined);
        onClose();
      },
    });
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <VStack spacing='xs' align='start'>
              <Heading as='h3' size='lg'>
                Bulk Catalog Management
              </Heading>
              <Text color='gray.500' fontSize='md' fontWeight='normal'>
                Activate or Deactivate items in restaurant items list using CSV upload.
              </Text>
            </VStack>
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody>
            <FileUploader
              style='style_01'
              message='Drag & Drop or click
              here to upload.'
              acceptedTypes={['text/csv']}
              multiple={false}
              onRemove={() => {
                setFile(undefined);
              }}
              onRemoveAll={() => {
                setFile(undefined);
              }}
              onUpload={(files) => {
                setFile(files[0]);
              }}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='gray' variant='ghost' me='sm' onClick={onClose}>
              Cancel
            </Button>
            <Button isLoading={isLoading} onClick={onUploadButton} isDisabled={!file} colorScheme='red' variant='solid'>
              Upload
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
